module.exports = __webpack_public_path__ + "static/media/bq.63fa6eef.svg";